/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type AccountManagerLink_viewer = {|
  +contactInfo: ?{|
    +phoneNumbers: ?{|
      +support: ?string;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountManagerLink_viewer",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ContactInfo",
      "name": "contactInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "support",
          "name": "phoneNumbers",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "INTERNATIONAL",
                  "type": "formatPhoneNumberTypes"
                }
              ],
              "name": "support",
              "storageKey": "support{\"formatType\":\"INTERNATIONAL\"}"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
